export enum MixpanelExtraParamsKeys {
  SOURCE = 'src',
  TAB = 'tab',
}

export const DeductionSourceParamValues: string[] = ['invoice'];

export interface MixpanelExtraParams {
  [MixpanelExtraParamsKeys.SOURCE]?: string;
  [MixpanelExtraParamsKeys.TAB]?: string;
}

export enum Modules {
  DEDUCTIONS = 'deductions',
}

// Consider moving this to a shared location:
enum QueryParams {
  SOURCE = 'src',
  TAB = 'tab',
}

export function getMixpanelExtraParams(moduleName: string, search: string): MixpanelExtraParams {
  const searchParams = new URLSearchParams(search);
  const extraParams: MixpanelExtraParams = {};
  if (searchParams.has(MixpanelExtraParamsKeys.SOURCE)) {
    let source: string | null = null;

    switch (moduleName) {
      case Modules.DEDUCTIONS: {
        const deductionSource = searchParams.get(QueryParams.SOURCE);
        if (deductionSource && DeductionSourceParamValues.includes(deductionSource)) {
          source = deductionSource;
        }
        break;
      }
      default:
        break;
    }
    if (source) {
      extraParams[MixpanelExtraParamsKeys.SOURCE] = source;
    }
  }
  if (searchParams.has(QueryParams.TAB)) {
    extraParams[MixpanelExtraParamsKeys.TAB] = searchParams.get(QueryParams.TAB) || '';
  }
  return extraParams;
}
